import React, {useEffect} from 'react';
import s from './styles.module.css'
import classNames from "classnames";
import {useLocalStorage} from "../../utils/useLocalStorage";

const Calculate = ({sendRequest, score, setValue, value, disabled}) => {
    const checkValue = value === null ? 0 : value;


    return (
        <div className={s.calculate}>
            <div className={s.value_box}>
                <div className={classNames(s.main_value, disabled && s.disabled)}
                     onClick={() => {
                         let result = 7;
                         console.log("score: " + score + ", result: " + result + ", token: " + localStorage.getItem("token"));
                         if (disabled === false) {
                             sendRequest(result, score, localStorage.getItem("token"));
                         }
                         return !disabled && setValue(result)}
                }>7
                </div>
                <div className={classNames(s.main_value, disabled && s.disabled)}
                     onClick={() => {
                         let result = 8;
                         console.log("score: " + score + ", result: " + result + ", token: " + localStorage.getItem("token"));
                         if (disabled === false) {
                             sendRequest(result, score, localStorage.getItem("token"));
                         }
                         return !disabled && setValue(result)}
                     }>8
                </div>
                <div className={classNames(s.main_value, disabled && s.disabled)}
                     onClick={() => {
                         let result = 9;
                         console.log("score: " + score + ", result: " + result + ", token: " + localStorage.getItem("token"));
                         if (disabled === false) {
                             sendRequest(result, score, localStorage.getItem("token"));
                         }
                         return !disabled && setValue(result)}
                     }>9
                </div>
            </div>
            <div className={s.value_box}>
                <div className={classNames(s.main_value, disabled && s.disabled)}
                     onClick={() => {
                         let result = 4;
                         console.log("score: " + score + ", result: " + result + ", token: " + localStorage.getItem("token"));
                         if (disabled === false) {
                             sendRequest(result, score, localStorage.getItem("token"));
                         }
                         return !disabled && setValue(result)}
                     }>4
                </div>
                <div className={classNames(s.main_value, disabled && s.disabled)}
                     onClick={() => {
                         let result = 5;
                         console.log("score: " + score + ", result: " + result + ", token: " + localStorage.getItem("token"));
                         if (disabled === false) {
                             sendRequest(result, score, localStorage.getItem("token"));
                         }
                         return !disabled && setValue(result)}
                     }>5
                </div>
                <div className={classNames(s.main_value, disabled && s.disabled)}
                     onClick={() => {
                         let result = 6;
                         console.log("score: " + score + ", result: " + result + ", token: " + localStorage.getItem("token"));
                         if (disabled === false) {
                             sendRequest(result, score, localStorage.getItem("token"));
                         }
                         return !disabled && setValue(result)}
                     }>6
                </div>
            </div>
            <div className={s.value_box}>
                <div className={classNames(s.main_value, disabled && s.disabled)}
                     onClick={() => {
                         let result = 1;
                         console.log("score: " + score + ", result: " + result + ", token: " + localStorage.getItem("token"));
                         if (disabled === false) {
                             sendRequest(result, score, localStorage.getItem("token"));
                         }
                         return !disabled && setValue(result)}
                     }>1
                </div>
                <div className={classNames(s.main_value, disabled && s.disabled)}
                     onClick={() => {
                         let result = 2;
                         console.log("score: " + score + ", result: " + result + ", token: " + localStorage.getItem("token"));
                         if (disabled === false) {
                             sendRequest(result, score, localStorage.getItem("token"));
                         }
                         return !disabled && setValue(result)}
                     }>2
                </div>
                <div className={classNames(s.main_value, disabled && s.disabled)}
                     onClick={() => {
                         let result = 3;
                         console.log("score: " + score + ", result: " + result + ", token: " + localStorage.getItem("token"));
                         if (disabled === false) {
                             sendRequest(result, score, localStorage.getItem("token"));
                         }
                         return !disabled && setValue(result)}
                     }>3
                </div>
            </div>
            <div className={s.value_box}>
                <div className={classNames(s.sub_value, disabled && s.disabled)}
                     onClick={() => {
                         let result = 10;
                         console.log("score: " + score + ", result: " + result + ", token: " + localStorage.getItem("token"));
                         if (disabled === false) {
                             sendRequest(result, score, localStorage.getItem("token"));
                         }
                         return !disabled && setValue(result)}
                     }>10
                </div>
                <div className={classNames(s.sub_value, disabled && s.disabled)}
                     onClick={() => {
                         let result = Number.isInteger(checkValue) ? (checkValue + 0.25 > 10 ? 0.25 : checkValue + 0.25) : 0.25;
                         console.log("score: " + score + ", result: " + result + ", token: " + localStorage.getItem("token"));
                         if (disabled === false) {
                             sendRequest(result, score, localStorage.getItem("token"));
                         }
                        return !disabled && setValue(result);
                     }}>0.25
                </div>
                <div className={classNames(s.sub_value, disabled && s.disabled)}
                     onClick={() => {
                         let result = Number.isInteger(checkValue) ? (checkValue + 0.5 > 10 ? 0.5 : checkValue + 0.5) : 0.5;
                         console.log("score: " + score + ", result: " + result + ", token: " + localStorage.getItem("token"));
                         if (disabled === false) {
                             sendRequest(result, score, localStorage.getItem("token"));
                         }
                         return !disabled && setValue(result);
                     }}>0.5
                </div>
                <div className={classNames(s.sub_value, disabled && s.disabled)}
                     onClick={() => {
                         let result = Number.isInteger(checkValue) ? (checkValue + 0.75 > 10 ? 0.75 : checkValue + 0.75) : 0.75;
                         console.log("score: " + score + ", result: " + result + ", token: " + localStorage.getItem("token"));
                         if (disabled === false) {
                             sendRequest(result, score, localStorage.getItem("token"));
                         }
                         return !disabled && setValue(result);
                     }}>0.75
                </div>
            </div>
        </div>
    );
};

export default Calculate;
